import './styles.scss'
import { Data } from './controller';


var Banner = {
  oninit: () => {
    Data.stats.fetch()
  },
  view: (vnode) => {
    if(!Data.stats.result) {
      return m("ons-progress-bar[indeterminate]")
    } else {
      const data = Data.stats.result.data
      return m(".ticker", data.slice(0,10).map((item) => {
        return m(".stat", [
          m("strong", item.country),
          m(".cases", item.total.toLocaleString('en'), " cases")
        ])
      }))
    }
  }
}

export default Banner
